package net.bothosting.docs.pages.community_resources

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initNode_and_website_uptime_monitorPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("community_resources/node_and_website_uptime_monitor.md", FrontMatterElement.Builder { addScalar("description", "Created by @agentzzrp"); }))
}

@Page("/community_resources/node-and-website-uptime-monitor")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Node_and_website_uptime_monitorPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("node-website-uptime-monitor") }) {
        org.jetbrains.compose.web.dom.Text("Node & Website Uptime Monitor")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thanks to Agent!")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Created and maintained by community members, this is an unofficial website. For official updates check out the #status-updates channel in the Discord Server")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Contributors: zilly.js, aidanthedev, .cerulean23, greenysoka, thedevjo, codenedits, legendphoenix66")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Link: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://monitor.livestatustracker.com/") {
                org.jetbrains.compose.web.dom.Text("https://monitor.livestatustracker.com/")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("API: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://monitor.livestatustracker.com/api") {
                org.jetbrains.compose.web.dom.Text("https://monitor.livestatustracker.com/api")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Updates can be found in its dedicated post (")
            com.varabyte.kobweb.silk.components.navigation.Link("https://discord.com/channels/884145104401608735/1317817006686470194") {
                org.jetbrains.compose.web.dom.Text("https://discord.com/channels/884145104401608735/1317817006686470194")
            }
            org.jetbrains.compose.web.dom.Text(")")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Check the status of bot-hosting.net's nodes and websites, updated every minute!")
        }
        org.jetbrains.compose.web.dom.Text(" CPU, Storage and latency stats for up to 4 locations are available.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("View uptime and alerts history for upto 365 days in the past!")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Add a Discord webhook url and get alerts straight to your Discord server, select types of alerts: nodes, sites, capacity and incidents; select priority monitors to get pinged when an alert is sent for a specific monitor (also works for custom monitors).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Login to report an issue with a monitor, once a certain threshold of reports is reached, an alert will be sent to all webhooks and the monitor's status will be changed so others can know about the issue.")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("You can only report a monitor once.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Light/Dark modes to view the site the way you want. Table and card view modes for mobile and desktop users. Drag and drop rows above or below each other to arrange them however you want. -# Right click then toggle row lock to enable this, after arranging rows, you should enable the row lock back again. Export uptime data via CSV & JSON. ")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Enable auto reload for the site to automatically reload every minute if wanted.")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("api") }) {
        org.jetbrains.compose.web.dom.Text("API:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Start monitoring the status for your bot-hosting.net server.")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Add up to 3 server monitors. (can be increased upon request)")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Get alerts straight to your connected webhook.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Get bot-hosting stats via the api for history, uptime, and your custom monitors.")
        }
    }
}
